module.exports = __webpack_public_path__ + "static/media/co.714d1724.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/co.svg
// module id = 803
// module chunks = 0